import { LoanSubmissionPdfType } from 'services/pdfs/loan'

import { IWorkflowConfig } from './type'

export const defaultDocumentWorkflows: Record<string, IWorkflowConfig> = {
  approval: {
    title: 'Generate "Conditional Loan Commitment"',
    enabled: true,
    isActive: true,
  },
  approval_all: {
    title: 'Generate "Conditional Loan Commitment" ALL',
    enabled: true,
    isActive: true,
  },
  commitment: {
    title: 'Generate "Final Conditional Loan Commitment"',
    enabled: true,
    isActive: true,
  },
  loan_setup_suspense: {
    title: 'Generate "Loan Setup Suspense"',
    enabled: true,
    isActive: true,
  },
}

export const pdfTypeToDocumentKey: Record<LoanSubmissionPdfType, keyof typeof defaultDocumentWorkflows> = {
  [LoanSubmissionPdfType.APPROVAL]: 'approval',
  [LoanSubmissionPdfType.APPROVAL_ALL]: 'approval_all',
  [LoanSubmissionPdfType.COMMITMENT]: 'commitment',
  [LoanSubmissionPdfType.Loan_SETUP_SUSPENSE]: 'loan_setup_suspense',
}

/** Extract PDF header from a configured button label like `Generate "Conditional Loan Commitment" ALL`. */
export const extractDocumentTitle = (buttonLabel: string): string => {
  const match = buttonLabel.match(/["']([^"']+)["']/)
  if (match?.[1]) return match[1]
  return buttonLabel
    .replace(/^Generate\s+/i, '')
    .replace(/\s+ALL$/i, '')
    .trim()
}

export const mergeDocumentConfig = (
  documents?: Record<string, IWorkflowConfig> | null,
): Record<string, IWorkflowConfig> => {
  const merged: Record<string, IWorkflowConfig> = { ...defaultDocumentWorkflows }
  if (!documents) return merged
  Object.keys(defaultDocumentWorkflows).forEach((key) => {
    merged[key] = {
      ...defaultDocumentWorkflows[key],
      ...documents[key],
      title: documents[key]?.title || defaultDocumentWorkflows[key].title,
      enabled: documents[key]?.enabled ?? defaultDocumentWorkflows[key].enabled,
    }
  })
  return merged
}
